import { parseArrayFromString } from '../../_common/client/parse-array-from-string';
import { getSessionStorage } from '../../_common/client/session-storage';
import { DimensionValueByType } from '../shared-types';

export const updateDimensionSelectionPriorityInStorage = (productId: string, selectedDimension: DimensionValueByType['type']) => {
    const storageKey = `ft5-dimension-selection-priority-for-product-${productId}`;
    const sessionStorage = getSessionStorage();
    const previousEntry = sessionStorage.getItem(storageKey);
    let dimensionSelectionOrder: string[] | undefined;
    if (previousEntry) {
        const previousOrder = parseArrayFromString(previousEntry);
        if (previousOrder) {
            const previousOrderWithoutSelectedDimension: string[] = previousOrder.filter(
                existingDimension => existingDimension !== selectedDimension
            );
            dimensionSelectionOrder = [selectedDimension, ...previousOrderWithoutSelectedDimension];
        }
    }
    sessionStorage.setItem(storageKey, JSON.stringify(dimensionSelectionOrder ?? [selectedDimension]));
};
